/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Voice_Manager_Default_Preview_TextInputs */

const en_voice_manager_default_preview_text = /** @type {(inputs: Voice_Manager_Default_Preview_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`John walks into the bar to see Alice already waiting for him. She sips her drink nervously.`)
};

const fr_voice_manager_default_preview_text = /** @type {(inputs: Voice_Manager_Default_Preview_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`John walks into the bar to see Alice already waiting for him. She sips her drink nervously.`)
};

const de_voice_manager_default_preview_text = /** @type {(inputs: Voice_Manager_Default_Preview_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`John betritt die Bar und sieht Alice bereits auf ihn warten. Sie nippt nervös an ihrem Getränk.`)
};

const it_voice_manager_default_preview_text = /** @type {(inputs: Voice_Manager_Default_Preview_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`John entra nel bar e trova Alice che lo sta già aspettando. Sorseggia nervosamente il suo drink.`)
};

const ru_voice_manager_default_preview_text = /** @type {(inputs: Voice_Manager_Default_Preview_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Джон заходит в бар и видит, что его уже ждет Элис. Она нервно отпивает свой напиток.`)
};

const es_voice_manager_default_preview_text = /** @type {(inputs: Voice_Manager_Default_Preview_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`John entra al bar y ve a Alice ya esperándolo. Ella bebe su bebida con nerviosismo.`)
};

const zh_cn2_voice_manager_default_preview_text = /** @type {(inputs: Voice_Manager_Default_Preview_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`约翰走进酒吧，看到爱丽丝已经在等他了。她紧张地抿了一口酒。`)
};

const ja_voice_manager_default_preview_text = /** @type {(inputs: Voice_Manager_Default_Preview_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ジョンがバーに入ると、アリスがすでに待っていた。彼女は緊張しながら飲み物を一口飲む。`)
};

const hi_voice_manager_default_preview_text = /** @type {(inputs: Voice_Manager_Default_Preview_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`जॉन बार में दाखिल होता है तो देखता है कि ऐलिस पहले से ही उसका इंतजार कर रही है। वह घबराकर अपनी ड्रिंक की चुस्की लेती है।`)
};

const pt_pt2_voice_manager_default_preview_text = /** @type {(inputs: Voice_Manager_Default_Preview_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`John entra no bar e vê Alice já à sua espera. Ela toma um gole da sua bebida, nervosa.`)
};

/**
* | output |
* | --- |
* | "John walks into the bar to see Alice already waiting for him. She sips her drink nervously." |
*
* @param {Voice_Manager_Default_Preview_TextInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const voice_manager_default_preview_text = /** @type {((inputs?: Voice_Manager_Default_Preview_TextInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Voice_Manager_Default_Preview_TextInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_voice_manager_default_preview_text(inputs)
	if (locale === "de") return de_voice_manager_default_preview_text(inputs)
	if (locale === "it") return it_voice_manager_default_preview_text(inputs)
	if (locale === "ru") return ru_voice_manager_default_preview_text(inputs)
	if (locale === "es") return es_voice_manager_default_preview_text(inputs)
	if (locale === "zh-CN") return zh_cn2_voice_manager_default_preview_text(inputs)
	if (locale === "ja") return ja_voice_manager_default_preview_text(inputs)
	if (locale === "hi") return hi_voice_manager_default_preview_text(inputs)
	if (locale === "pt-PT") return pt_pt2_voice_manager_default_preview_text(inputs)
	return en_voice_manager_default_preview_text(inputs)
});